import { useQuery } from '@tanstack/react-query';

import { paymentProviderTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';
import { Departments } from '@/types';

export const getPaymentProviders: paymentProviderTypes.GetPaymentProviders = (params) => {
  return axios.get(`/payment-providers`, { params });
};

type QueryFnType = typeof getPaymentProviders;

type UseGetPaymentProvidersOptions = {
  department: Departments;
  config?: QueryConfig<QueryFnType>;
};

export const useGetPaymentProviders = ({
  config = {},
  department,
}: UseGetPaymentProvidersOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['payment-providers', department],
    enabled: !!department,
    queryFn: () => getPaymentProviders({ department }),
  });
};
